module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-modules container"
  }, [_c('div', {
    staticClass: "show-subscribe"
  }, [_c('h3', [_vm._v("Subscribe to the show")]), _vm._v(" "), (_vm.socialLinks) ? _c('div', _vm._l((_vm.socialLinks), function(link, i) {
    return _c('a', {
      key: i,
      attrs: {
        "target": "_blank",
        "href": link.url,
        "rel": "noopener noreferrer"
      }
    }, [_c('span', {
      staticClass: "icon",
      class: ("" + (link.name.toLowerCase().replace(/ /g, '-')))
    }, [_c('iconify-icon', {
      attrs: {
        "icon": link.icon
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(link.name))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "newsletter-subscribe",
    attrs: {
      "id": "newsletter"
    }
  }, [_c('h3', [_vm._v("Sign up for the newsletter")]), _vm._v(" "), _c('div', {
    staticClass: "newsletter-form-container"
  }, [_c('iframe', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://longestshortesttime.substack.com/embed",
      "width": "480",
      "height": "160",
      "frameborder": "0",
      "scrolling": "no"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "site-info container"
  }, [(!_vm.isHome) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      },
      "tag": "h4"
    }
  }, [_vm._v("The Longest Shortest Time")]) : _c('h4', {
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_vm._v("The Longest Shortest Time")]), _vm._v(" "), _c('nav', [_c('div', {
    staticClass: "nav-center nav-menu"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_c('span', [_vm._v("Stories")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'About'
      }
    }
  }, [_c('span', [_vm._v("About")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("©2010-" + _vm._s(_vm.currentYear) + " The Longest Shortest Time LLC")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://longestshortesttime.supportingcast.fm/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', [_vm._v("Join the Club")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://the-longest-shortest-time.myshopify.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', [_vm._v("Shop")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-center nav-menu secondary-nav"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "/terms"
    }
  }, [_c('span', [_vm._v("Terms of Service")])]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "/privacy"
    }
  }, [_c('span', [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "/cookie-policy"
    }
  }, [_c('span', [_vm._v("Cookie Policy")])]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "javascript:UC_UI.showSecondLayer();",
      "id": "usercentrics-psl"
    }
  }, [_c('span', [_vm._v("Privacy\n            Settings")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04221e84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SiteFooter.vue
// module id = 756
// module chunks = 1